import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {User} from "../../../interfaces/user";
import {ApiService} from "../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "../../../services/auth.service";
import { NoFrameComponent } from '../../../frames/no-frame/no-frame.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { KazButtonComponent } from '../../../components/kaz-button/kaz-button.component';

@Component({
    selector: 'kaz-validate',
    templateUrl: './validate.component.html',
    styleUrls: ['./validate.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NoFrameComponent, FaIconComponent, KazButtonComponent]
})
export class ValidateComponent implements OnInit {
  private _api = inject(ApiService);
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _auth = inject(AuthenticationService);

  user: User | null = null;
  mailRequested: boolean = false;

  async ngOnInit() {
    if (this._auth.isAuthenticated())
      await this._router.navigate(['main']);


    this._route.paramMap.subscribe(params => {
      const userId = params.get('id')
      if (userId !== null) {
        this.getUser(userId);
      }
    });
  }

  private async getUser(userId: string) {
    try {
      this.user = await this._api.getOwnUser(userId);
    } catch (err) {
      console.log(err);
    }
  }

  async sendVerifyMail(){
    try {
      if (this.user !== null){
        const data = await this._api.sendVerifyMail(this.user.id);
      }
      this.mailRequested = true;
    } catch (err) {
      console.log(err)
    }
  }

}
